import React, { FC } from 'react'

import EmptyComponent from './Empty'
import SpacerComponent from './Spacer'
import TextComponent from './Text'
import ImageComponent from './Image'
import VideoComponent from './Video'
import FileComponent from './File'
import TableComponent from './Table'
import HTMLComponent from './HTMLCell'
import BookingDetailsComponent from './BookingDetails'

import {
  ILayout_Cell,
  ILayout_RenderMap,
} from '../types/layout'

const defaultRenderers: ILayout_RenderMap = {
  empty: EmptyComponent,
  spacer: SpacerComponent,
  text: TextComponent,
  image: ImageComponent,
  video: VideoComponent,
  file: FileComponent,
  table: TableComponent,
  html: HTMLComponent,
  booking_details: BookingDetailsComponent,
}

interface RenderComponentProps {
  cell: ILayout_Cell,
  editMode?: boolean,
  renderers?: Partial<ILayout_RenderMap>,
}

const RenderComponent: FC<React.PropsWithChildren<RenderComponentProps>> = ({
  cell,
  editMode = true,
  renderers = {},
}) => {
  const useRenderers = Object.assign({}, defaultRenderers, renderers)
  const Component = useRenderers[cell.type]
  if(!Component) throw new Error(`no component type found for ${cell.type}`)
  return (
    <Component
      cell={ cell }
      editMode={ editMode }
    />
  )
}

export default RenderComponent